import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import Label from './formLabel'
import NumberFormat from 'react-number-format'

/**
 * @param {setFieldValue} formvalue setting formik value
 */
const Inputs = (props) => {
    const { label, name, placeholder, errors, setFieldValue, prefix='$', suffix='', isThousandSeparator=true, decimalScale=false, allowNegative=false} = props

    return (
        <Field name={name}>
            {({ field, form }) => {
                return (
                    <div className='form-group'>
                        <Label name={name} label={label} />
                        <div
                            className={`input-wrapper`}
                        >
                        <NumberFormat
                            thousandSeparator={isThousandSeparator}
                            decimalScale={decimalScale !== false ? decimalScale : undefined}
                            allowNegative={allowNegative}
                            prefix={prefix}
                            id={name}
                            name={name}
                            placeholder={placeholder}
                            value={field.value}
                            onBlur={form.handleBlur}
                            className={`form-control input-val ${
                                errors[name] ? 'input-error' : ''
                            }`}
                            onValueChange={(val) => {
                                const { floatValue } = val
                                setFieldValue(name, floatValue)
                            }}
                        />
                        {suffix}
                        </div>
                        <ErrorMessage component={TextError} name={name} />
                    </div>
                )
            }}
        </Field>
    )
}

export default Inputs
